<script lang="ts">
    import { DEFAULT_BOX, DEFAULT_LAYOUT } from '$lib/components/constants';
    import { TRANSITION_DELAY } from '$lib/global/constants';

    import { cn } from '$lib/utils/cn';

    import Answer from './Answer.svelte';
    import { getBoxAttributes } from '../_utils/getBoxAttributes';
    import Box from '../_wrappers/Box.svelte';
    import Text from '../Text/Text.View.svelte';

    import type { Box as BoxType, Align } from '$lib/types/Components/SharedTypes';
    import type { TransitionEffect } from '$lib/types/Theme';
    import type { ComponentProps } from 'svelte';

    export let id = '';
    export let align: Align = 'center';
    export let wysiwygHtml: string | undefined = undefined;
    export let color = 'black';
    export let box: BoxType;
    export let onAnswerClick: ComponentProps<Answer>['onClick'];
    export let onAnswerMouseEnter: ComponentProps<Answer>['onMouseEnter'];
    export let answers: Omit<ComponentProps<Answer>, 'onClick' | 'onMouseEnter'>[] = [];
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let layout = DEFAULT_LAYOUT;

    const { isInColumn, isInSingleColumn, isInMultiColumn } = layout;

    const answerWrapperClass = cn(
        'fun-mt-6 fun-flex fun-flex-wrap fun-items-stretch fun-justify-center fun-gap-4 fun-leading-[1.25] md:fun-mt-10',
        {
            'fun-mx-auto fun-max-w-md': isInMultiColumn,
        },
    );

    const answerClass = cn('relative', {
        'fun-max-w-[calc(50%-8px)] fun-basis-[calc(50%-8px)]': isInColumn && !isInSingleColumn,
        'fun-max-w-[calc(50%-8px)] fun-basis-[calc(50%-8px)] md:fun-max-w-[calc(25%-12px)] md:fun-basis-[calc(25%-12px)]':
            !isInColumn || isInSingleColumn,
    });
</script>

<Box {id} {...getBoxAttributes({ box, isInColumn })} {transitionDelay} {transitionEffect}>
    <Text transitionEffect="none" {wysiwygHtml} {align} {color} box={DEFAULT_BOX} {layout} />

    <div class={answerWrapperClass}>
        {#each answers as answer, index (answer.id)}
            <div class={answerClass}>
                <Answer
                    {...answer}
                    onClick={onAnswerClick}
                    onMouseEnter={onAnswerMouseEnter}
                    {transitionEffect}
                    transitionDelay={transitionDelay + index * TRANSITION_DELAY}
                    responsePercentage={answer.responsePercentage}
                />
            </div>
        {/each}
    </div>
</Box>
